import CustomError from '@/util/customError.js'
import { grlSellerIds, jtrSellerIds, gtxSellerIds, kkdaySellerIds } from '~/config'

const module = {
  registered: false,
  namespaced: true,
  state: () => ({
    cityDetail: {},
    hntCityUrl: '',
    magazines: [],
    itineraries: [],
    breadcrumbs: [],
    themeFilter: {},
    product: {},
    seller: {},
    faqList: [],
    guides: [],
    //bestProducts: [],
    //relatedProducts: [],
    isGorillaProduct: false,
    isGtxProduct: false,
    isJtrProduct: false,
    isExternalProduct: false,
    isKkdayProudct: false,
    reviewRate: {
      score: 0,
      total: 0,
    },
  }),
  getters: {
    defaultCriteria: () => ({
      deal: {
        instant: false,
        last: false,
        early: false,
        promotion: false,
      },
      price: {
        min: 0,
        max: -1,
      },
      category: undefined,
      theme: undefined,
      sort: 'RECOMMEND',
      paging: { no: 1, limit: 15 },
    }),
    cityDetail: (state) => state.cityDetail,
    hntCityUrl: (state) => state.hntCityUrl,
    magazines: (state) => state.magazines,
    itineraries: (state) => state.itineraries,
    breadcrumbs: (state) => state.breadcrumbs,
    themeFilter: (state) => state.themeFilter,
    product: (state) => state.product,
    seller: (state) => state.seller,
    faqList: (state) => state.faqList,
    guides: (state) => state.guides,
    unusedCalendar: (state) => state.product.unusedCalendar,
    //bestProducts: state => state.bestProducts,
    //relatedProducts: state => state.relatedProducts,
    isGorillaProduct: (state) => state.isGorillaProduct,
    isGtxProduct: (state) => state.isGtxProduct,
    isJtrProduct: (state) => state.isJtrProduct,
    isExternalProduct: (state) => state.isExternalProduct,
    isKkdayProudct: (state) => state.isKkdayProudct,
    reviewRate: (state) => state.reviewRate,
  },
  actions: {
    async getCityDetail({ commit }, friendlyPath) {
      try {
        const { data } = await this.$http.get(`/platform/v1/city/${friendlyPath}/info`)
        await commit('setCityDetail', data)
      } catch (err) {
        throw err
      }
    },
    async getHntCityUrl({ commit }, hntCityCode) {
      try {
        const { data } = await this.$http.get(`/platform/v1/hnt-city/${hntCityCode}`)
        await commit('setHntCityUrl', data)
      } catch (err) {
        throw err
      }
    },
    async getThemes(_, { friendlyPath, limit }) {
      try {
        const { data } = await this.$http.get(`/contents/v1/theme/city/${friendlyPath}`, {
          params: { limit },
        })
        if (data && Array.isArray(data)) {
          data.forEach((row) => {
            if (Array.isArray(row.products)) {
              row.products.forEach((product) => {
                product.cities.sort((a, b) => {
                  return a.friendlyPath === friendlyPath ? -1 : 1
                })
              })
            }
          })
        }
        return data
      } catch (err) {
        throw err
      }
    },
    async getMagazines({ commit }, { friendlyPath, limit }) {
      try {
        const { data } = await this.$http.get(`/contents/v1/magazine/city/${friendlyPath}`, {
          params: { limit },
        })
        await commit('setMagazines', data)
      } catch (err) {
        if (
          err &&
          err.data &&
          typeof err.data.message === 'string' &&
          err.data.message === '도시 링크가 맞지 않습니다.'
        ) {
          throw new CustomError('도시 링크가 맞지 않습니다.', 404)
        } else {
          throw err
        }
      }
    },
    async getThemeListFilter({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/theme/list-filter')
        await commit('setThemeFilter', data)
      } catch (err) {
        throw err
      }
    },
    async getItineraries({ commit }, friendlyPath) {
      try {
        const { data } = await this.$http.get(`/trip/v1/city/${friendlyPath}`)
        await commit('setItineraries', data)
      } catch (err) {
        throw err
      }
    },
    async getProducts(_, { friendlyPath, criteria }) {
      try {
        let _criteria = JSON.parse(JSON.stringify(criteria))

        if (_criteria.category && _criteria.category.toLowerCase() === 'all')
          _criteria.category = null
        if (_criteria.theme && _criteria.theme.toLowerCase() === 'all') _criteria.theme = null

        if (_criteria.price && _criteria.price.limit) {
          _criteria.price.limit = undefined
        }
        if (_criteria.paging.total) {
          _criteria.paging.total = undefined
        }

        const { data } = await this.$http.post(`/product/v1/city/${friendlyPath}`, _criteria)
        if (data && data.products) {
          data.products.forEach((product) => {
            product.cities.sort((a, b) => {
              return a.friendlyPath === friendlyPath ? -1 : 1
            })
          })
        }

        return data
      } catch (err) {
        throw err
      }
    },
    async getProduct({ commit, dispatch }, { productId, friendlyPath }) {
      try {
        const response = await this.$http.get(`/product/v1/detail/${productId}`)
        const data = response.data
        if (!data) {
          throw new CustomError('상품 정보가 없습니다.', 404)
        }

        if (data.cities) {
          data.cities.sort((a, b) => {
            return a.friendlyPath === friendlyPath ? -1 : 1
          })
        }
        await commit('setProduct', data)
        await dispatch('pushVideoToGallery', { video: data.video, gallery: data.images })
        await dispatch('pushVideoToGallery', {
          video: data.info && data.info.video,
          gallery: data.info && data.info.images,
        })
        await dispatch('pushVideoToGallery', {
          video: data.useway && data.useway.video,
          gallery: data.useway && data.useway.images,
        })
        await dispatch('pushVideoToGallery', {
          video: data.warning && data.warning.video,
          gallery: data.warning && data.warning.images,
        })
        await dispatch('pushVideoToGallery', {
          video: data.cancelPolicy && data.cancelPolicy.video,
          gallery: data.cancelPolicy && data.cancelPolicy.images,
        })
        await data.place.forEach((place, idx) => {
          dispatch('pushVideoToGallery', {
            video: place && place.video,
            gallery: data.place[idx] && data.place[idx].images,
          })
        })
        return data
      } catch (err) {
        throw err
      }
    },
    async pushVideoToGallery(_, { video, gallery }) {
      try {
        if (!video || !video.source || typeof video.source !== 'string') return

        const matched = video.source.match(
          /(http:|https:|)\/\/(player.|www.|m.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
        )
        const id = matched[6]
        const final = (url) => {
          gallery.push({
            type: 'video',
            source: video.source,
            text: video.text,
            url: url,
          })
        }

        if (matched[3].indexOf('youtu') > -1) {
          final(`https://img.youtube.com/vi/${id}/0.jpg`)
        } else if (matched[3].indexOf('vimeo') > -1) {
          // browser
          if (typeof XMLHttpRequest === 'function') {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', `https://vimeo.com/api/v2/video/${id}.json`, true)
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 4) {
                // JSON.parse does not evaluate the attacker's scripts.
                var resp = JSON.parse(xhr.responseText)
                final(resp[0] ? resp[0].thumbnail_large : '')
              }
            }
            xhr.send()
          } else {
            // server
            const { data } = await this.$http.get(`https://vimeo.com/api/v2/video/${id}.json`)
            final(data[0] ? data[0].thumbnail_large : '')
          }
        }
      } catch (err) {
        throw err
      }
    },
    async getSeller({ commit }, productId) {
      try {
        const { data } = await this.$http.get(`/product/v1/detail/${productId}/seller`)
        await commit('setSeller', data)

        if (data && data.id) {
          commit('setIsExternalProduct', data.id)
        }

        return data
      } catch (err) {
        throw err
      }
    },
    async getFaqList({ commit }, productId) {
      try {
        const { data } = await this.$http.get(`/product/v1/detail/${productId}/faq`)
        await commit('setFaqList', data)
        return data
      } catch (err) {
        throw err
      }
    },
    async getGuides({ commit }, productId) {
      try {
        const { data } = await this.$http.get(`/product/v1/detail/${productId}/guide`)
        await commit('setGuides', data)
      } catch (err) {
        throw err
      }
    },
    /** 상품 상세페이지 상태 초기화 */
    reset({ commit }) {
      commit('setProduct', {})
      commit('setSeller', {})
      commit('setFaqList', [])
    },
  },
  mutations: {
    setCityDetail(state, cityDetail) {
      state.cityDetail = cityDetail
    },
    setHntCityUrl(state, hntCityUrl) {
      state.hntCityUrl = hntCityUrl
    },
    setMagazines(state, data) {
      state.magazines = data
    },
    setThemeFilter(state, filter) {
      state.themeFilter = filter
    },
    setItineraries(state, data) {
      state.itineraries = data
    },
    setProduct(state, data) {
      state.product = data
    },
    setSeller(state, seller) {
      state.seller = seller
    },
    setFaqList(state, faqList) {
      state.faqList = faqList
    },
    setGuides(state, guides) {
      state.guides = guides
    },
    setLikeCountOfProduct(state, { like, total }) {
      state.product.wish.inMyList = like
      state.product.wish.count = total
    },

    /*
    setBestProducts(state, bestProducts) {
      state.bestProducts = bestProducts;
    },
    setRelatedProducts(state, relatedProducts) {
      state.relatedProducts = relatedProducts;
    },
    */

    setIsExternalProduct(state, sellerId) {
      const externalSellerIds = [
        ...grlSellerIds,
        ...gtxSellerIds,
        ...jtrSellerIds,
        ...kkdaySellerIds,
      ]
      state.isExternalProduct = externalSellerIds.includes(sellerId)
      state.isGorillaProduct = grlSellerIds.includes(sellerId)
      state.isGtxProduct = gtxSellerIds.includes(sellerId)
      state.isJtrProduct = jtrSellerIds.includes(sellerId)
      state.isKkdayProudct = kkdaySellerIds.includes(sellerId)
    },
    setReviewRate(state, reviewRate) {
      state.reviewRate = reviewRate
    },
  },
}

export default module
